$(function () {
    new bootstrap.Tooltip('html', {
        selector: '[data-bs-toggle="tooltip"]',
        container: 'body'
    });

    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl)
    })

    $('[data-toggle="collapse-partial"]').on('click', function () {
        $(this).closest('.collapse-partial').css('max-height', 'none');
        $(this).remove();
    });

    $(document).on('click', '[data-app-modal-template]', async function (e) {
        e.preventDefault();
        const $button = $(this);

        const template = $button.data('app-modal-template');
        const title = $button.data('app-modal-title') || $button.attr('title') || '';
        const size = $button.data('app-modal-size') || '';
        const param = $button.data('app-modal-param') || {};
        const onEscape = $button.attr('data-app-modal-on-escape') === 'true';
        const closeButton = $button.attr('data-app-modal-close-button') !== 'false';
        const backdrop = (() => {
            const rawBackdrop = $button.attr('data-app-modal-backdrop');
            return rawBackdrop === 'static' ? 'static' :
                rawBackdrop === 'true' ? true :
                    rawBackdrop === 'false' ? false : null;
        })();

        const $modal = bootbox.dialog({
            title,
            message: await Handlebars.render(template, param),
            size,
            closeButton,
            backdrop,
            onEscape
        });

        $button.trigger('app:modal:rendered', [$modal, param]);
    });

    $(document).on('click', 'a[href^="/policy/"]', async function (e) {
        e.preventDefault();
        const $button = $(this);
        const href = $(this).attr('href');
        const policyName = href.replace(/^\/policy\//, '');
        const html = await fetch(`/static/doc/${policyName}.html`).then(response => response.text());

        const $html = $(`<div>${html}</div><div class="text-center"><button type="button" class="btn btn-primary" data-bs-dismiss="modal">Close</button></div>`);

        const $modal = bootbox.dialog({
            message: $html,
            size: 'large'
        });
    });
});

$(function () {
    Object.assign(Handlebars, {
        // Use colons here, not equals signs
        registeredRawTemplates: new Map(),

        getRawTemplate: async function (name) {
            if (this.registeredRawTemplates.has(name)) {
                return this.registeredRawTemplates.get(name);
            }

            try {
                const version = "1.0";
                const file = `/static/template/${name}.hbs?v=${version}`;
                const response = await fetch(file);

                if (!response.ok) throw new Error(`HTTP ${response.status}`);

                const templateText = await response.text();

                this.registeredRawTemplates.set(name, templateText);

                return templateText;
            } catch (err) {
                console.error(`Failed to fetch template [${name}]:`, err);
                return null;
            }
        },

        render: async function (name, param) {
            try {
                const rawTemplate = await this.getRawTemplate(name);
                if (!rawTemplate) return $('<div>Template Error</div>');

                const compiledTemplate = Handlebars.compile(rawTemplate);
                const html = compiledTemplate(param);
                const $content = $(html);

                // Cloudflare Turnstile Support
                if (typeof turnstile !== 'undefined') {
                    $content.find('.cf-turnstile-container').each(function () {
                        turnstile.render(this, {
                            sitekey: window.CLOUDFLARE_TURNSTILE_SITEKEY
                        });
                    });
                }

                return $content;

            } catch (error) {
                // Check for missing partials
                const partialMatch = error.message.match(/The partial (.+) could not be found/);
                if (partialMatch) {
                    const partialName = partialMatch[1];
                    const rawPartial = await this.getRawTemplate(partialName);

                    if (rawPartial) {
                        this.registerPartial(partialName, rawPartial);
                        return this.render(name, param); // Retry with correct 'param'
                    }
                }
                console.error('Handlebars Render Error:', error);
                return $('<div>Render Error</div>');
            }
        }
    });


    // Helper Registration
    Handlebars.registerHelper({
        eq: (v1, v2) => v1 === v2,
        gt: (v1, v2) => v1 > v2,
        n_: function (singular, plural, count) {
            if (typeof count === 'object') count = 0;
            const finalCount = parseInt(count, 10);

            if (typeof n_ !== 'undefined') {
                return n_(singular, plural, finalCount);
            }
            return (finalCount === 1) ? singular : plural;
        },
        jsonEncode: function (value) {
            if (value === undefined || value === null) {
                return '';
            }
            return JSON.stringify(value);
        },
        formatCurrency: function (value, currency, locale) {
            // 1. Return empty states immediately
            if (value === null || value === undefined || value === '') {
                return value;
            }

            const floatValue = parseFloat(value);
            if (isNaN(floatValue)) {
                return value;
            }

            // 2. Clear out the internal Handlebars options object if it bled into arguments
            if (typeof currency === 'object') { currency = undefined; }
            if (typeof locale === 'object') { locale = undefined; }

            // 3. Safe fallback logic can now execute cleanly
            const selectedLocale = locale || 'en-US';
            const selectedCurrency = currency || 'USD';

            try {
                const currencyFormatter = new Intl.NumberFormat(selectedLocale, {
                    style: 'currency',
                    currency: selectedCurrency
                });

                return currencyFormatter.format(floatValue);
            } catch (e) {
                // Fallback safety if someone passes an invalid currency/locale code string
                return '$' + floatValue.toFixed(2);
            }
        },
        formatDate: function (dateString, format) {
            // 1. Fallback handling if no date string is provided
            if (!dateString) return '';

            // 2. Default to 'Y-m-d' if format argument isn't provided or is a Handlebars options hash object
            if (typeof format !== 'string') {
                format = 'Y-m-d';
            }

            const date = new Date(dateString);

            // Guard against invalid date strings
            if (isNaN(date.getTime())) return dateString;

            // 3. Extract standard date components
            const pad = (num) => String(num).padStart(2, '0');

            const components = {
                'Y': date.getFullYear(),
                'm': pad(date.getMonth() + 1),
                'n': date.getMonth() + 1,
                'd': pad(date.getDate()),
                'j': date.getDate(),
                'H': pad(date.getHours()),
                'i': pad(date.getMinutes()),
                's': pad(date.getSeconds())
            };

            // 4. Replace tokens inline to build the target string format
            return format.replace(/[YmndjHis]/g, (match) => components[match]);
        }
    });
});


window.reveal = function () {
    var reveals = document.querySelectorAll(".reveal-slideup, .reveal-fadein");

    for (var i = 0; i < reveals.length; i++) {
        var windowHeight = window.innerHeight;
        var elementTop = reveals[i].getBoundingClientRect().top;
        var elementVisible = 150;

        if (elementTop < windowHeight - elementVisible) {
            reveals[i].classList.remove("reveal-state-ready");
        } else {
            reveals[i].classList.add("reveal-state-ready");
        }
    }
}
window.addEventListener("scroll", reveal);